import { format, isValid, differenceInCalendarDays } from 'date-fns';

/**
 * Safe wrapper around date-fns format.
 * Returns fallback when date is null, undefined, or invalid.
 */
export const safeFormat = (date, fmt, fallback = '—') => {
    if (!date) return fallback;
    const d = date instanceof Date ? date : new Date(date);
    return isValid(d) ? format(d, fmt) : fallback;
};

const IN_STOCK_STATUS_ID = 3;

/**
 * Returns the number of calendar days an order has been in stock, relative to `now`.
 *
 * Uses calendar-day difference (not 24h periods):
 *   - accepted 20.02 at 19:40, checked on 23.02 → 3 days
 *   - accepted at 23:59 Monday, checked at 00:01 Tuesday → 1 day
 *
 * `now` is injectable for deterministic unit testing.
 * Returns null if the order has no IN_STOCK status entry.
 */
export const getDaysInStock = (order, now = new Date()) => {
    if (!order.orderStatuses?.length) return null;

    const inStockEntry = order.orderStatuses
        .filter((status) => status.statusId === IN_STOCK_STATUS_ID)
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))[0];

    if (!inStockEntry) return null;

    return differenceInCalendarDays(now, new Date(inStockEntry.createdAt));
};
